module.exports = __webpack_public_path__ + "img/japan-cardiovascular-diseases-male.62c20bb7.png";